import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Util } from '../../utils/util'
import { HTTPConfig } from './http.model'
import { HTTPServiceParameter } from './http-parameter.model'

const CONFIG_DEFAULTS: HTTPConfig = {
  dataType: 'json',
  withCredentials: false,
  retryAllowed: false,
  //contentType: 'application/json',
  'X-REP-PLAN-ID': '',
  'X-REP-SEARCH-VALUE-PRIVATE': '',
  'X-XSRF-TOKEN': '',
  'X-REP-TARGET-POID': '',
  'X-REP-AVT': '',
}

@Injectable()
export class HttpService {
  constructor(private httpClient: HttpClient) {}

  public delete = (param: HTTPServiceParameter) => {
    const url = this.replaceUrlPlaceholders(param.url, param.urlParameters)
    return this.httpClient.delete(url, this.createOptions(param.config))
  }

  public get = <T>(param: HTTPServiceParameter) => {
    const url = this.replaceUrlPlaceholders(param.url, param.urlParameters)
    return this.httpClient.get<T>(url, this.createOptions(param.config))
  }

  public post = (param: HTTPServiceParameter) => {
    const url = this.replaceUrlPlaceholders(param.url, param.urlParameters)
    const options = this.createOptions(param.config)

    return this.httpClient.post(url, param.body, options)
  }

  public put = (param: HTTPServiceParameter) => {
    const url = this.replaceUrlPlaceholders(param.url, param.urlParameters)
    const options = this.createOptions(param.config)
    return this.httpClient.put(url, param.body, options)
  }

  private createOptions = (httpConfig: HTTPConfig) => {
    const config = Object.assign({}, CONFIG_DEFAULTS, httpConfig)
    const option = {
      headers: this.createHeader(config),
      withCredentials: config.withCredentials,
    }

    return option
  }

  private createHeader = (httpConfig: HTTPConfig): HttpHeaders => {
    const headersToSet: any = {}

    if (httpConfig['X-REP-PLAN-ID']) {
      headersToSet['X-REP-PLAN-ID'] = httpConfig['X-REP-PLAN-ID']
    }
    if (httpConfig['X-REP-AVT']) {
      headersToSet['X-REP-AVT'] = httpConfig['X-REP-AVT']
    }
    if (httpConfig['X-REP-SEARCH-VALUE-PRIVATE']) {
      headersToSet['X-REP-SEARCH-VALUE-PRIVATE'] =
        httpConfig['X-REP-SEARCH-VALUE-PRIVATE']
    }
    if (httpConfig['X-REP-TARGET-POID']) {
      headersToSet['X-REP-TARGET-POID'] = httpConfig['X-REP-TARGET-POID']
    }
    if (httpConfig['X-HTTP-Method-Override']) {
      headersToSet['X-HTTP-Method-Override'] =
        httpConfig['X-HTTP-Method-Override']
    }
    if (Util.getCookie('XSRF-TOKEN')) {
      headersToSet['X-XSRF-TOKEN'] = Util.getCookie('XSRF-TOKEN')
    } else {
      headersToSet['X-XSRF-TOKEN'] = ''
    }

    const headers = new HttpHeaders(headersToSet)
    return headers
  }

  /**
   * Function replaces placeholders from URL and returns the updated url
   * @param url - URL to be parsed
   * @param parameters - parameters, placeholders to be replaced with
   */
  private replaceUrlPlaceholders(
    url: string,
    parameters: { [key: string]: any },
  ): string {
    if (!parameters) {
      return url
    }

    let parsedUrl = url
    for (const key in parameters) {
      if (parameters[key]) {
        parsedUrl = parsedUrl.replace(`{${key}}`, parameters[key])
      }
    }
    return parsedUrl
  }
}
